"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = urlTransform;

var _qs = _interopRequireDefault(require("qs"));

var _url = require("url");

var _omit = _interopRequireDefault(require("./utils/omit"));

var _merge = _interopRequireDefault(require("./utils/merge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint no-useless-escape: 0 */
var rxClean = /(\(:[^\)]+\)|:[^\/]+\/?)/g;
/**
 * Url modification
 * @param  {String} url     url template
 * @param  {Object} params  params for url template
 * @param  {Object} options transformation options, accepts +delimiter+, +arrayFormat+,
 *                          +qsStringifyOptions+ and +qsParseOptions+
 * @return {String}         result url
 */

function urlTransform(url, params, options) {
  if (!url) {
    return "";
  }

  params || (params = {});
  var usedKeys = {};
  var urlWithParams = Object.keys(params).reduce(function (url, key) {
    var value = params[key];
    var rx = new RegExp("(\\(:".concat(key, "\\)|:").concat(key, ")(/?)"), "g");
    return url.replace(rx, function (_, _1, slash) {
      usedKeys[key] = value;
      return value ? value + slash : value;
    });
  }, url);

  if (!urlWithParams) {
    return urlWithParams;
  }

  var _parse = (0, _url.parse)(urlWithParams),
      protocol = _parse.protocol,
      host = _parse.host,
      path = _parse.path;

  var cleanURL = host ? "".concat(protocol, "//").concat(host).concat(path.replace(rxClean, "")) : path.replace(rxClean, "");
  var usedKeysArray = Object.keys(usedKeys);

  if (usedKeysArray.length !== Object.keys(params).length) {
    var urlObject = cleanURL.split("?");
    options || (options = {});
    var _options = options,
        arrayFormat = _options.arrayFormat,
        delimiter = _options.delimiter;

    var qsParseOptions = _objectSpread({
      arrayFormat: arrayFormat,
      delimiter: delimiter
    }, options.qsParseOptions);

    var mergeParams = (0, _merge["default"])(urlObject[1] && _qs["default"].parse(urlObject[1], qsParseOptions), (0, _omit["default"])(params, usedKeysArray));

    var qsStringifyOptions = _objectSpread({
      arrayFormat: arrayFormat,
      delimiter: delimiter
    }, options.qsStringifyOptions);

    var urlStringParams = _qs["default"].stringify(mergeParams, qsStringifyOptions);

    return "".concat(urlObject[0], "?").concat(urlStringParams);
  }

  return cleanURL;
}

module.exports = exports.default;
//# sourceMappingURL=urlTransform.js.map